export default "__VITE_ASSET__5d08b704__"